// @flow

import type {ApplicationState} from '../../types'
import type {SessionState} from '../types'

export function getUser(appState: ApplicationState): ApplicationState {
  return appState
}

function _getUser(state: SessionState): SessionState {
  return state
}

getUser.internal = _getUser
